import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const DepartamentoService = {
  fetchDepartamentos: async (token) => {
    try {
      const response = await axios.get(buildApiUrl('/api/locations/departments'), {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error en DepartamentoService.fetchDepartamentos:", error);
      throw error;
    }
  },
};
